import Vue from 'vue'
import Router from 'vue-router'
import { normalizeURL, decode } from 'ufo'
import { interopDefault } from './utils'
import scrollBehavior from './router.scrollBehavior.js'

const _8c312c32 = () => interopDefault(import('../../../pages/buy.vue' /* webpackChunkName: "pages/buy" */))
const _1b5f3ff3 = () => interopDefault(import('../../../pages/index.vue' /* webpackChunkName: "pages/index" */))
const _35f239ec = () => interopDefault(import('../../../pages/login.vue' /* webpackChunkName: "pages/login" */))
const _7978c713 = () => interopDefault(import('../../../pages/payment-failed.vue' /* webpackChunkName: "pages/payment-failed" */))
const _34a4ec9e = () => interopDefault(import('../../../pages/payment-pending.vue' /* webpackChunkName: "pages/payment-pending" */))
const _57b92a1d = () => interopDefault(import('../../../pages/payment-success.vue' /* webpackChunkName: "pages/payment-success" */))
const _8bf1c1ec = () => interopDefault(import('../../../pages/profile.vue' /* webpackChunkName: "pages/profile" */))
const _67a2bec7 = () => interopDefault(import('../../../pages/questionnaire/index.vue' /* webpackChunkName: "pages/questionnaire/index" */))
const _07b01641 = () => interopDefault(import('../../../pages/sell.vue' /* webpackChunkName: "pages/sell" */))
const _6063af12 = () => interopDefault(import('../../../pages/settings.vue' /* webpackChunkName: "pages/settings" */))
const _4c8a396a = () => interopDefault(import('../../../pages/theme.vue' /* webpackChunkName: "pages/theme" */))
const _015f1972 = () => interopDefault(import('../../../pages/transactions/index.vue' /* webpackChunkName: "pages/transactions/index" */))
const _7e72f24c = () => interopDefault(import('../../../pages/transfer.vue' /* webpackChunkName: "pages/transfer" */))
const _d5bec922 = () => interopDefault(import('../../../pages/transactions/_id.vue' /* webpackChunkName: "pages/transactions/_id" */))

const emptyFn = () => {}

Vue.use(Router)

export const routerOptions = {
  mode: 'history',
  base: '/',
  linkActiveClass: 'nuxt-link-active',
  linkExactActiveClass: 'nuxt-link-exact-active',
  scrollBehavior,

  routes: [{
    path: "/buy",
    component: _8c312c32,
    name: "buy___en"
  }, {
    path: "/es",
    component: _1b5f3ff3,
    name: "index___es"
  }, {
    path: "/et",
    component: _1b5f3ff3,
    name: "index___et"
  }, {
    path: "/login",
    component: _35f239ec,
    name: "login___en"
  }, {
    path: "/payment-failed",
    component: _7978c713,
    name: "payment-failed___en"
  }, {
    path: "/payment-pending",
    component: _34a4ec9e,
    name: "payment-pending___en"
  }, {
    path: "/payment-success",
    component: _57b92a1d,
    name: "payment-success___en"
  }, {
    path: "/profile",
    component: _8bf1c1ec,
    name: "profile___en"
  }, {
    path: "/pt",
    component: _1b5f3ff3,
    name: "index___pt"
  }, {
    path: "/questionnaire",
    component: _67a2bec7,
    name: "questionnaire___en"
  }, {
    path: "/sell",
    component: _07b01641,
    name: "sell___en"
  }, {
    path: "/settings",
    component: _6063af12,
    name: "settings___en"
  }, {
    path: "/theme",
    component: _4c8a396a,
    name: "theme___en"
  }, {
    path: "/transactions",
    component: _015f1972,
    name: "transactions___en"
  }, {
    path: "/transfer",
    component: _7e72f24c,
    name: "transfer___en"
  }, {
    path: "/es/buy",
    component: _8c312c32,
    name: "buy___es"
  }, {
    path: "/es/login",
    component: _35f239ec,
    name: "login___es"
  }, {
    path: "/es/payment-failed",
    component: _7978c713,
    name: "payment-failed___es"
  }, {
    path: "/es/payment-pending",
    component: _34a4ec9e,
    name: "payment-pending___es"
  }, {
    path: "/es/payment-success",
    component: _57b92a1d,
    name: "payment-success___es"
  }, {
    path: "/es/profile",
    component: _8bf1c1ec,
    name: "profile___es"
  }, {
    path: "/es/questionnaire",
    component: _67a2bec7,
    name: "questionnaire___es"
  }, {
    path: "/es/sell",
    component: _07b01641,
    name: "sell___es"
  }, {
    path: "/es/settings",
    component: _6063af12,
    name: "settings___es"
  }, {
    path: "/es/theme",
    component: _4c8a396a,
    name: "theme___es"
  }, {
    path: "/es/transactions",
    component: _015f1972,
    name: "transactions___es"
  }, {
    path: "/es/transfer",
    component: _7e72f24c,
    name: "transfer___es"
  }, {
    path: "/et/buy",
    component: _8c312c32,
    name: "buy___et"
  }, {
    path: "/et/login",
    component: _35f239ec,
    name: "login___et"
  }, {
    path: "/et/payment-failed",
    component: _7978c713,
    name: "payment-failed___et"
  }, {
    path: "/et/payment-pending",
    component: _34a4ec9e,
    name: "payment-pending___et"
  }, {
    path: "/et/payment-success",
    component: _57b92a1d,
    name: "payment-success___et"
  }, {
    path: "/et/profile",
    component: _8bf1c1ec,
    name: "profile___et"
  }, {
    path: "/et/questionnaire",
    component: _67a2bec7,
    name: "questionnaire___et"
  }, {
    path: "/et/sell",
    component: _07b01641,
    name: "sell___et"
  }, {
    path: "/et/settings",
    component: _6063af12,
    name: "settings___et"
  }, {
    path: "/et/theme",
    component: _4c8a396a,
    name: "theme___et"
  }, {
    path: "/et/transactions",
    component: _015f1972,
    name: "transactions___et"
  }, {
    path: "/et/transfer",
    component: _7e72f24c,
    name: "transfer___et"
  }, {
    path: "/pt/buy",
    component: _8c312c32,
    name: "buy___pt"
  }, {
    path: "/pt/login",
    component: _35f239ec,
    name: "login___pt"
  }, {
    path: "/pt/payment-failed",
    component: _7978c713,
    name: "payment-failed___pt"
  }, {
    path: "/pt/payment-pending",
    component: _34a4ec9e,
    name: "payment-pending___pt"
  }, {
    path: "/pt/payment-success",
    component: _57b92a1d,
    name: "payment-success___pt"
  }, {
    path: "/pt/profile",
    component: _8bf1c1ec,
    name: "profile___pt"
  }, {
    path: "/pt/questionnaire",
    component: _67a2bec7,
    name: "questionnaire___pt"
  }, {
    path: "/pt/sell",
    component: _07b01641,
    name: "sell___pt"
  }, {
    path: "/pt/settings",
    component: _6063af12,
    name: "settings___pt"
  }, {
    path: "/pt/theme",
    component: _4c8a396a,
    name: "theme___pt"
  }, {
    path: "/pt/transactions",
    component: _015f1972,
    name: "transactions___pt"
  }, {
    path: "/pt/transfer",
    component: _7e72f24c,
    name: "transfer___pt"
  }, {
    path: "/",
    component: _1b5f3ff3,
    name: "index___en"
  }, {
    path: "/es/transactions/:id",
    component: _d5bec922,
    name: "transactions-id___es"
  }, {
    path: "/et/transactions/:id",
    component: _d5bec922,
    name: "transactions-id___et"
  }, {
    path: "/pt/transactions/:id",
    component: _d5bec922,
    name: "transactions-id___pt"
  }, {
    path: "/transactions/:id",
    component: _d5bec922,
    name: "transactions-id___en"
  }],

  fallback: false
}

export function createRouter (ssrContext, config) {
  const base = (config._app && config._app.basePath) || routerOptions.base
  const router = new Router({ ...routerOptions, base  })

  // TODO: remove in Nuxt 3
  const originalPush = router.push
  router.push = function push (location, onComplete = emptyFn, onAbort) {
    return originalPush.call(this, location, onComplete, onAbort)
  }

  const resolve = router.resolve.bind(router)
  router.resolve = (to, current, append) => {
    if (typeof to === 'string') {
      to = normalizeURL(to)
    }
    return resolve(to, current, append)
  }

  return router
}
